import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { Redux } from '../..'
import { GygQueryOptions } from '@/src/views/components/master-pricing-list/types'
import { GygMenuTemplate } from '@/src/types/apps/gygMenuTemplates'

interface MenuTemplateInitialState {
  menuTemplates?: GygMenuTemplate[] | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: MenuTemplateInitialState = {
  menuTemplates: null,
  loading: false,
  success: null,
  error: null
}

interface MenuTemplatesResponse {
  data: GygMenuTemplate[]
}

export const getMenuTemplates = createAsyncThunk<MenuTemplatesResponse, GygQueryOptions, Redux>(
  'gygMenuTemplates/getAllMenuTemplates',
  async (gygQueryOptions, { extra }) => {
    const { data: responseData } = await extra.httpClient.get(`menu-templates`, {
      params: gygQueryOptions
    })

    return responseData
  }
)

const gygMenuTemplateSlice = createSlice({
  name: 'getAllMenuTemplates',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getMenuTemplates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getMenuTemplates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.menuTemplates = action.payload.data
      })
      .addCase(getMenuTemplates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch menu templates'
      })
  }
})

export default gygMenuTemplateSlice.reducer
